import { BusinessTypes, TimezoneData } from "@/types";
import { GetterTree } from "vuex";
import { GlobalState } from "@/types/store/clientzone/global";
import { RootState } from "@/types/store/clientzone";

export const getters: GetterTree<GlobalState, RootState> = {
  GET_BUSINESS_TYPES: (state): Array<BusinessTypes> => state.businessTypes,
  GET_TIMEZONES: (state): Array<TimezoneData> => state.timezones
}
